import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import UserRoles from "../../constants/UserRoles";
import {Button} from "reactstrap";
import PriorityHigh from "@material-ui/icons/PriorityHigh";
import CheckBox from "@material-ui/icons/CheckBox";
import {confirmAlert} from "react-confirm-alert";

export default class IdleTasksClicked extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Recurring_Tasks_Clicked._name, API.RequestType.READ_ALL);
		super(props, model);
	}

	fetchData = async (state) => {
		this.state.limit = 20;
		this.state.sorted = [];
		this.state.page = 0;
		if (!this.state.filter || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}

		this.state.filter.task = this.props.task;

		this.setState({loading: true});
		setTimeout(() => this.fetchDataActual(state), 100);
	};

	render() {
		const {data, pages, limit, loading} = this.state;
		let columns = [
			{
				Header: "Created (Server Time)",
				id: "created",
				accessor: obj => (moment(obj.created).local().format('MM/DD/YYYY h:mm A'))
			},
			{
				Header: "User",
				id: "user_name",
				accessor: obj => obj.user_name
			},
			{
				Header: "Task",
				id: "task_name",
				accessor: obj => obj.task_name
			}
		]
		return (
			<Card>
				<CardContent>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: true,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}